var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('k-video-grid',{attrs:{"items":_vm.system ? _vm.system_channels : _vm.developer ? _vm.developer_channels : _vm.filtered_channels,"storage-key":_vm.system ? 'monitor-system' : _vm.developer ? 'monitor-developer' : 'monitor',"max-entries":1000},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var item = ref.item;
return [_c('item',{attrs:{"data":item,"developer":_vm.developer}})]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }